module.exports = __webpack_public_path__ + "static/media/spin.70dd9766.gif";